<style lang="scss" scoped>
.page {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-flow: column;
    position: relative;
    background-image: linear-gradient(
        180deg,
        var(--primary) 0%,
        var(--primary-dark) 100%
    );

    .chart-container {
        position: relative;
        .chart-border-bottom {
            height: 1px;
            width: 100%;
            position: absolute;
            background: #fff;
            top: 185px;
        }
    }
    ::v-deep #bar-chart {
        max-width: 300px;
        margin: auto;
    }

    .blur {
        filter: blur(3px);
    }
}
</style>

<template>
    <div class="page px-0 py-12 py-md-60 d-lg-none" v-if="currentUser">
        <template v-if="scheduleOverview">
            <a v-if="profession_type_id !== 2" href="#" @click="goToCurrentWeek" class="text-white text-center mb-32" v-html="$t('sidebar.your-schedule', { week: currentUser.user.current_week })"></a>
            <div v-if="profession_type_id !== 2" class="mb-60 d-flex flex-wrap px-60 justify-content-between">
                <div class="d-flex flex-column">
                    <i-to-bed class="i-42 mx-auto mb-16 fill-white"></i-to-bed>
                    <template v-if="!currentUser.user.trial">
                        <p v-if="scheduleOverview.in_bed" class="text-white text-center">{{ scheduleOverview.in_bed }}</p>
                        <p v-else class="text-white text-center"></p>
                    </template>
                    <p v-else class="text-white text-center blur">23:00</p>
                </div>
                <div class="d-flex flex-column">
                    <i-get-out class="i-42 mx-auto mb-16 fill-white"></i-get-out>
                    <template v-if="!currentUser.user.trial">
                        <p v-if="scheduleOverview.awaken" class="text-white text-center">{{ scheduleOverview.awaken }}</p>
                        <p v-else class="text-white text-center"></p>
                    </template>
                    <p v-else class="text-white text-center blur">07:30</p>
                </div>

                <!-- not Trial -->
                <!-- not in week 0 or 1 -->
                <!-- current week does NOT equal recommended week -->
                <!-- no schedule found -->
                <!-- not shift worker -->
                <div v-if="!currentUser.user.trial && currentUser.user.current_week !== 0 && currentUser.user.current_week !== currentUser.user.recommended_week  && currentUser.user.current_week !== 1 && (!scheduleOverview.awaken && !scheduleOverview.in_bed) && currentUser.user.profession_type_id !== 2" class="w-100 text-white text-center small">
                    {{ $t('sidebar.no_schedule_past_week') }}
                </div>

                <!-- not Trial -->
                <!-- not in week 0 or 1 -->
                <!-- current week DOES equal recommended week -->
                <!-- no schedule found -->
                <!-- not shift worker -->
                <div v-if="!currentUser.user.trial && currentUser.user.current_week !== 0 && currentUser.user.current_week === currentUser.user.recommended_week  && currentUser.user.current_week !== 1 && (!scheduleOverview.awaken && !scheduleOverview.in_bed) && currentUser.user.profession_type_id !== 2" class="w-100 text-white text-center small">
                    {{ $t('sidebar.schedule_will_unlock_soon') }}
                </div>

                <!-- not Trial -->
                <!-- In week 1 -->
                <!-- no schedule found -->
                <div v-if="!currentUser.user.trial && currentUser.user.current_week === 1 &&  currentUser.user.current_day === 7 && (!scheduleOverview.awaken && !scheduleOverview.in_bed) && profession_type_id !== 2" class="w-100 text-white text-center small">
                    {{ $t('sidebar.schedule_will_unlock_tomorrow') }}
                </div>

                <div v-if="currentUser.user.current_day < 7 && profession_type_id !== 2" class="w-100 text-white text-center small mt-16">
                    {{ $t('sidebar.schedule_will_unlock_in', { days: 7 - currentUser.user.current_day }) }}
                </div>

                <a v-else-if="currentUser.user.trial && profession_type_id !== 2" href="#" @click="$modal.show('purchase-plan')" class="w-100 text-white text-center small mt-16">
                    {{ $t('sidebar.schedule_will_unlock_now') }}
                </a>
            </div>
        </template>

        <div class="chart-container" v-if="chartData">
            <p class="text-white text-center mb-16">{{ $t('sidebar.your-sleep-evolution') }}</p>
            <bar-chart :chart-data="chartData" :height="185"></bar-chart>
            <div class="chart-border-bottom"></div>
        </div>
    </div>
</template>

<script>
import { BarChart } from '@/components/charts'

export default {
    name: 'page-platform-schedule',

    components: { BarChart },

    data() {
        return {
            profession_type_id: 0,
        }
    },

    mounted() {
        this.$store.dispatch('schedule/readScheduleOverview', { user_id: this.currentUser.user.id, force: false })
        this.$store.dispatch('user/readProfession', { user_id: this.currentUser.user.id, id: this.currentUser.user.profession_id }).then((profession) => {
            this.profession_type_id = profession.profession_type_id
        })
    },

    methods: {
        goToCurrentWeek() {
            this.$store.dispatch('schedule/setWeek', this.currentUser.user.current_week)
        },
    },

    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        },
        scheduleOverview() {
            return this.$store.getters['schedule/overview']
        },
        chartData() {
            if (!this.scheduleOverview) {
                return null;
            }
            let se = this.scheduleOverview.sleep_efficiencies

            if (se.length === 1) {
                se = [se[0], 0, 0, 0, 0, 0]
            }

            return {
                labels: Object.values(se).map(e => (e) ? e + '%' : '0%'),
                datasets: [
                    {
                        backgroundColor: Object.values(se).map(e => (e && e >= 85) ? '#c0ae66' : 'rgba(255, 255, 255, 0.9)'),
                        data: Object.values(se).map(e => (e) ? e : 0),
                    },
                    {
                        backgroundColor: 'rgba(242, 242, 242, 0.1)',
                        data: Object.values(se).map(e => (e) ? 100 - e : 100),
                    }
                ]
            }
        }
    }
}
</script>